module.exports = {
  __depends__: [
    require(166)
  ],
  __init__: [ 'bpmnGlobalConnect' ],
  bpmnGlobalConnect: [ 'type', require(19) ]
};
